<!-- SiteFooter.vue -->
<template>
  <footer class="nebula-site-footer">

    <div v-if="isLoading" class="nebula-footer-skeleton">
      <!-- 스켈레톤 UI -->
<!--      <div class="skeleton skeleton-banner"></div>-->
      <div class="skeleton skeleton-menu"></div>
      <div class="skeleton skeleton-company"></div>
<!--      <div class="skeleton skeleton-customer"></div>-->
<!--      <div class="skeleton skeleton-badges"></div>-->
      <div class="skeleton skeleton-copyright"></div>
    </div>

    <div v-else>
      <!-- 상단 배너 (보톡스 광고) -->
<!--      <div class="nebula-footer-banner">-->
<!--        <div class="nebula-container">-->
<!--          <img :src="require('@/assets/user/footer/하단_띠배너.png')" alt="하단 띠배너" />-->
<!--        </div>-->
<!--      </div>-->

      <!-- 회사 메뉴 -->
      <div class="nebula-company-menu">
        <div class="nebula-container">
          <ul class="nebula-menu-list">
            <li class="nebula-menu-item" v-for="(item, index) in menuItems" :key="index">
              <a href="#" @click.prevent="openModal(item)">{{ item.title }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 모달 컴포넌트 -->
      <div class="nebula-modal" v-if="isModalOpen" @click.self="closeModal">
        <div class="nebula-modal-content">
          <div class="nebula-modal-header">
            <h2>{{ activeItem.title }}</h2>
            <button class="nebula-modal-close" @click="closeModal">&times;</button>
          </div>
          <div class="nebula-modal-body">
            <div v-html="activeItem.content"></div>
          </div>
        </div>
      </div>

      <!-- 회사 정보 -->
      <div class="nebula-company-info">
        <div class="nebula-container">
          <div class="nebula-info-grid">
            <!-- 회사 로고 및 정보 -->
            <div class="nebula-company-details">
              <div class="nebula-company-logo">
                <img src="@/assets/images/footer_logo.png" alt="로고">
<!--                <img v-if="storeConfig.logoUrl" :src="getImageUrl(storeConfig.logoUrl)" alt="회사 로고">-->
<!--                 <img src="@/assets/images/logo_new.png" alt="로고">-->
              </div>
<!--              <div><a href="#" class="nebula-company-intro-btn">회사소개서</a></div>-->
            </div>
            <div class="nebula-company-text">
<!--              <p> -->
<!--                상호 : {{ '주식회사 에스디팜' }} | 대표 : {{ storeConfig.ceoName || '장상도' }}-->
<!--              </p> -->
<!--              <p>주소 : {{ getFullAddress() }}</p> -->
<!--              <p>사업자등록번호 : {{ storeConfig.businessNumber || '123-45-67890' }} | 통신판매업신고 : 제 2025-고양일산동-0660호</p>-->
<!--              <p></p>-->
<!--              <p>의약품도매상허가번호 : 제 2022-3940139-00002호 | 이메일 : {{ storeConfig.email || 'cs@doctormarket.kr' }}</p> -->
<!--              <p></p>-->
<!--              <p>개인정보책임관리자 : {{ storeConfig.ceoName || '홍길동' }}</p>-->

              <p>사업자등록번호 : {{ storeConfig.businessNumber || '510-87-01695' }} | 상호 : 주식회사 에스디팜 | 대표 : {{ storeConfig.ceoName || '장상도' }}</p>
              <p>주소 : {{ getFullAddress() }}
<!--                경기 고양시 일산동구 무궁화로 32-23 3층 301호-->
              </p>
              <p>통신판매업신고 : 제 2025-고양일산동-0660호 | 이메일 : {{ storeConfig.email || 'help@doctormarket.co.kr' }}</p>
              <p>© {{ currentYear }} SDPharm Co., Ltd. All Rights Reserved.</p>
            </div>
            <!-- 고객센터 정보 -->
            <div class="nebula-customer-center">
              <div class="nebula-center-header">
                <div class="nebula-center-icon">
                  <img src="@/assets/user/footer/free-icon-apple-831309.png" alt="임시 이미지">
                </div>
                <h3 class="nebula-center-title">고객센터</h3>
              </div>
              <div class="nebula-center-info">
                <p>운영시간 : 월요일 - 금요일 09:00 ~ 18:00</p> <p>(점심시간 12:30 ~ 13:30)</p>
                <p>TEL. {{ storeConfig.phone || '080-855-8282' }} | FAX. 031-908-0414</p>
              </div>

              <!-- 문의 버튼 -->
<!--              <div class="nebula-contact-buttons">-->
<!--                <a href="#" class="nebula-contact-btn">-->
<!--                  <div class="nebula-contact-icon">-->
<!--                    <img src="@/assets/user/footer/free-icon-chat-bot-8649607.png" alt="임시 이미지">-->
<!--                  </div>-->
<!--                  <span>채팅문의</span>-->
<!--                </a>-->
<!--                <a href="#" class="nebula-contact-btn">-->
<!--                  <div class="nebula-contact-icon">-->
<!--                    <img src="@/assets/user/footer/free-icon-chat-bot-8794620.png" alt="임시 이미지">-->
<!--                  </div>-->
<!--                  <span>전화문의</span>-->
<!--                </a>-->
<!--                <a href="#" class="nebula-contact-btn">-->
<!--                  <div class="nebula-contact-icon">-->
<!--                    <img src="@/assets/user/footer/free-icon-fax-machine-5075753.png" alt="임시 이미지">-->
<!--                  </div>-->
<!--                  <span>FAX문의</span>-->
<!--                </a>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>

      <!-- 인증 배지 -->
<!--      <div class="nebula-certifications">-->
<!--        <div class="nebula-container">-->
<!--          <div class="nebula-badges">-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo1.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo2.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo3.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--            <div class="nebula-badge">-->
<!--              <img :src="require('@/assets/user/footer/bnr-footer-logo4.png')" alt="하단 띠배너" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 저작권 정보 -->
      <div class="nebula-copyright" style="display: none">
        <div class="nebula-container">
          <p>
<!--            © 2025 {{ storeConfig.name || 'DOCTORMARKET' }}. All Rights Reserved.-->
            © 2025 Doctormarket All RIGHTS RESERVED.
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from 'axios';
import { getBaseURL } from '@/utils/config';

export default {
  name: 'SiteFooter',
  data() {
    return {
      isLoading: true,
      isModalOpen: false,
      activeItem: { title: '', content: '' },
      happytalk: null, // �� 해피톡 인스턴스 추가
      menuItems: [
        {
          title: '회사소개',
          href: 'http://www.sdpharm.co.kr/' // ← 새창으로 열 링크
        },
        {
          title: '이용약관',
          content: `<div class="modal-content">
  <h3>닥터마켓 이용약관</h3>

  <div class="terms-section">
    <h4>제1조 (목적)</h4>
    <p>이 약관은 주식회사 에스디팜(이하 "회사")이 운영하는 닥터마켓(www.doctormarket.kr, 이하 "닥터마켓")에서 제공하는 전자상거래 관련 서비스(이하 "서비스")를 이용함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
  </div>

  <div class="terms-section">
    <h4>제2조 (정의)</h4>
    <ol>
      <li>"닥터마켓"이란 회사가 재화 또는 용역(이하 "재화 등")을 이용자에게 제공하기 위하여 컴퓨터, 모바일 등 정보통신설비를 이용하여 재화 등을 거래할 수 있도록 설정한 가상의 영업장을 말합니다.</li>
      <li>"이용자"란 "닥터마켓"에 접속하여 이 약관에 따라 "닥터마켓"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
      <li>"회원"이라 함은 "닥터마켓"에 회원등록을 한 자로서, 계속적으로 "닥터마켓"이 제공하는 서비스를 이용할 수 있는 자를 말합니다.</li>
      <li>"비회원"이라 함은 회원에 가입하지 않고 "닥터마켓"이 제공하는 서비스를 이용하는 자를 말합니다.</li>
      <li>"의약품"이라 함은 약사법에 따른 의약품을 말하며, "전문의약품"은 의사 또는 치과의사의 처방전 없이는 구입할 수 없는 의약품을 말합니다.</li>
    </ol>
  </div>

  <div class="terms-section">
    <h4>제3조 (약관의 게시와 개정)</h4>
    <ol>
      <li>회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함), 전화번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 "닥터마켓" 초기 서비스화면에 게시합니다.</li>
      <li>회사는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약사법」, 「의료기기법」, 「개인정보보호법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
      <li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 "닥터마켓"의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
    </ol>
  </div>

  <div class="terms-section">
    <h4>제4조 (의약품 판매에 관한 특별 규정)</h4>
    <ol>
      <li>닥터마켓에서 판매되는 전문의약품은 관련 법령에 따라 적법한 절차를 통해서만 구매가 가능합니다.</li>
      <li>회원은 전문의약품 구매 시 유효한 처방전을 제출해야 하며, 회사는 처방전의 유효성을 확인한 후 판매를 진행합니다.</li>
      <li>회사는 의약품의 안전한 배송을 위해 전문 냉장배송 시스템을 운영하며, 품질 유지를 위한 모든 조치를 취합니다.</li>
      <li>의약품 관련 부작용이 발생할 경우, 즉시 의사와 상담하고 회사에 통보해야 합니다.</li>
    </ol>
  </div>

  <div class="terms-section">
    <h4>제5조 (서비스의 제공 및 변경)</h4>
    <ol>
      <li>회사는 다음과 같은 업무를 수행합니다.
        <ol type="a">
          <li>재화 또는 용역에 대한 정보 제공 및 구매계약의 체결</li>
          <li>구매계약이 체결된 재화 또는 용역의 배송</li>
          <li>기타 회사가 정하는 업무</li>
        </ol>
      </li>
      <li>회사는 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 사유로 서비스의 내용을 변경할 수 있습니다. 이 경우에는 변경된 서비스의 내용 및 제공일자를 명시하여 현재의 서비스 내용을 게시한 곳에 즉시 공지합니다.</li>
    </ol>
  </div>

  <div class="terms-section">
    <h4>제6조 (회원가입)</h4>
    <ol>
      <li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</li>
      <li>회사는 다음 각 호에 해당하는 회원가입신청에 대하여는 승낙을 하지 않을 수 있습니다.
        <ol type="a">
          <li>가입신청자가 이 약관 제7조에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
          <li>실명이 아니거나 타인의 명의를 이용한 경우</li>
          <li>허위의 정보를 기재하거나, 회사가 요구하는 정보를 제공하지 않은 경우</li>
          <li>만 14세 미만의 아동이 법정대리인(부모 등)의 동의를 얻지 않은 경우</li>
        </ol>
      </li>
    </ol>
  </div>

  <p class="terms-note">※ 전체 이용약관은 총 20개 조항으로 구성되어 있으며, 자세한 내용은 닥터마켓 홈페이지에서 확인하실 수 있습니다.</p>
</div>`
        },
        {
          title: '개인정보처리방침',
          content: `<div class="modal-content">
  <h3>개인정보처리방침</h3>

  <div class="privacy-section">
    <p class="privacy-intro">주식회사 에스디팜(이하 '회사')은 「개인정보보호법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」을 준수하며, 관련 법령에 의거한 개인정보처리방침을 정하여 이용자 권익 보호에 최선을 다하고 있습니다.</p>
  </div>

  <div class="privacy-section">
    <h4>1. 개인정보의 처리 목적</h4>
    <p>회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</p>

    <ol type="a">
      <li>
        <strong>회원 가입 및 관리</strong>
        <p>회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증, 회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지 등을 목적으로 개인정보를 처리합니다.</p>
      </li>
      <li>
        <strong>재화 또는 서비스 제공</strong>
        <p>의약품·의료기기 제공, 맞춤 서비스 제공, 본인인증, 연령인증, 요금결제·정산, 물품배송 또는 청구서 등 발송, 금융거래 본인인증 및 금융서비스, 처방전 확인 등을 목적으로 개인정보를 처리합니다.</p>
      </li>
      <li>
        <strong>마케팅 및 광고에의 활용</strong>
        <p>신규 서비스(제품) 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.</p>
      </li>
      <li>
        <strong>의약품 판매 관련 법적 의무 이행</strong>
        <p>약사법 등 관련 법령에 따른 처방전 관리, 의약품 판매기록 보관 등 법령상 의무 이행을 목적으로 개인정보를 처리합니다.</p>
      </li>
    </ol>
  </div>

  <div class="privacy-section">
    <h4>2. 개인정보의 처리 및 보유기간</h4>
    <p>회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.</p>
    <ul>
      <li><strong>회원 가입 및 관리:</strong> 회원탈퇴 시까지 (다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지)</li>
      <li><strong>전자상거래 등에서의 소비자 보호에 관한 법률:</strong>
        <ul>
          <li>계약 또는 청약철회 등에 관한 기록: 5년</li>
          <li>대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
          <li>소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
        </ul>
      </li>
      <li><strong>의약품 판매 관련 기록:</strong>
        <ul>
          <li>처방전에 따른 조제기록: 처방전 발급일부터 2년</li>
          <li>의약품 판매기록: 판매일로부터 5년</li>
        </ul>
      </li>
    </ul>
  </div>

  <div class="privacy-section">
    <h4>3. 개인정보의 제3자 제공</h4>
    <p>회사는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</p>
    <p>회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</p>
    <table class="privacy-table">
      <tr>
        <th>제공받는 자</th>
        <th>제공목적</th>
        <th>제공항목</th>
        <th>보유 및 이용기간</th>
      </tr>
      <tr>
        <td>용마로지스</td>
        <td>상품 배송</td>
        <td>이름, 주소, 연락처</td>
        <td>배송완료 후 90일</td>
      </tr>
      <tr>
        <td>결제대행사</td>
        <td>결제처리</td>
        <td>이름, 결제정보</td>
        <td>5년</td>
      </tr>
      <tr>
        <td>보건복지부, 건강보험심사평가원</td>
        <td>의약품 판매기록 보고</td>
        <td>처방전 정보, 판매 의약품 정보</td>
        <td>관계 법령에 따른 보존기간</td>
      </tr>
    </table>
  </div>

  <div class="privacy-section">
    <h4>4. 정보주체와 법정대리인의 권리·의무 및 행사방법</h4>
    <p>정보주체는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. 권리 행사는 회사에 대해 개인정보 보호법 시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며, 회사는 이에 대해 지체없이 조치하겠습니다.</p>
  </div>

  <p class="privacy-note">※ 전체 개인정보처리방침은 총 10개 항목으로 구성되어 있으며, 자세한 내용은 닥터마켓 홈페이지에서 확인하실 수 있습니다.</p>
</div>`
        }
//         {
//           title: '이용안내',
//           content: `<div class="modal-content">
//   <h3>이용안내</h3>
//
//   <div class="guide-section">
//     <h4>회원가입 안내</h4>
//     <ol>
//       <li>닥터마켓 웹사이트(www.doctormarket.kr) 또는 모바일 앱에 접속합니다.</li>
//       <li>상단 메뉴에서 '회원가입' 버튼을 클릭합니다.</li>
//       <li>필수 정보(이메일, 비밀번호, 이름, 연락처 등)를 입력합니다.</li>
//       <li>의료인 회원의 경우, 의사/약사 면허번호 인증 과정이 추가됩니다.</li>
//       <li>이용약관 및 개인정보처리방침에 동의합니다.</li>
//       <li>인증 이메일을 통해 본인인증을 완료합니다.</li>
//       <li>회원가입이 완료되면 닥터마켓의 모든 서비스를 이용하실 수 있습니다.</li>
//     </ol>
//   </div>
//
//   <div class="guide-section">
//     <h4>상품 주문 방법</h4>
//     <ol>
//       <li>원하는 상품을 검색하거나 카테고리에서 찾아 상품 상세 페이지로 이동합니다.</li>
//       <li>상품 정보와 가격을 확인한 후 '장바구니 담기' 또는 '바로구매' 버튼을 클릭합니다.</li>
//       <li>전문의약품의 경우, 처방전 업로드가 필요합니다.</li>
//       <li>배송지 정보와 결제 방법을 선택합니다.</li>
//       <li>최종 주문 내역을 확인하고 결제를 진행합니다.</li>
//       <li>주문이 완료되면 주문 확인 메일과 SMS가 발송됩니다.</li>
//     </ol>
//
//     <div class="guide-note">
//       <h5>전문의약품 주문 시 유의사항</h5>
//       <ul>
//         <li>전문의약품은 반드시 유효한 처방전이 필요합니다.</li>
//         <li>처방전은 이미지 파일(.jpg, .png) 또는 PDF 형식으로 업로드해 주세요.</li>
//         <li>처방전은 발행일로부터 3일 이내의 것만 유효합니다.</li>
//         <li>업로드된 처방전은 전문 약사가 검토 후 승인 절차를 거칩니다.</li>
//       </ul>
//     </div>
//   </div>
//
//   <div class="guide-section">
//     <h4>결제 방법 안내</h4>
//     <p>닥터마켓에서는 다양한 결제 방법을 제공합니다:</p>
//     <ul>
//       <li><strong>신용카드:</strong> 국내 모든 신용카드로 결제 가능합니다. (일시불/할부)</li>
//       <li><strong>무통장입금:</strong> 주문 후 안내된 계좌로 입금하시면 입금 확인 후 배송이 진행됩니다.</li>
//       <li><strong>간편결제:</strong> 카카오페이, 네이버페이, 페이코, 토스 등 다양한 간편결제를 지원합니다.</li>
//       <li><strong>휴대폰결제:</strong> 소액 결제의 경우 휴대폰 결제도 가능합니다. (수수료 발생)</li>
//     </ul>
//     <p class="guide-emphasis">법인 구매의 경우, 세금계산서 발행이 가능합니다. 주문 시 요청사항에 기재해 주시거나 고객센터로 문의해 주세요.</p>
//   </div>
//
//   <div class="guide-section">
//     <h4>배송 안내</h4>
//     <ul>
//       <li><strong>배송 방법:</strong> 용마로지스를 통해 배송됩니다.</li>
//       <li><strong>배송 지역:</strong> 전국 배송 가능 (제주 및 도서산간 지역은 추가 배송비 발생)</li>
//       <li><strong>배송 비용:</strong> 기본 배송비 3,000원 (5만원 이상 구매 시 무료배송)</li>
//       <li><strong>배송 일정:</strong>
//         <ul>
//           <li>일반배송: 결제 확인 후 1-2일 이내 출고, 출고 후 1-2일 내 수령 (영업일 기준)</li>
//           <li>특급배송: 결제 확인 후 당일 출고, 출고 후 1일 내 수령 (영업일 기준)</li>
//           <li>바로배송: 오전 11시 이전 주문 시 당일 수령 가능 (서울 지역 한정)</li>
//         </ul>
//       </li>
//       <li><strong>의약품 냉장배송:</strong> 전문의약품 및 냉장보관이 필요한 상품은 전용 냉장박스로 안전하게 배송됩니다.</li>
//     </ul>
//     <p class="guide-emphasis">주문 상태는 '마이페이지 > 주문/배송 조회'에서 실시간으로 확인하실 수 있습니다.</p>
//   </div>
//
//   <div class="guide-section">
//     <h4>교환/반품/환불 안내</h4>
//     <p>상품 수령 후 문제가 있을 경우 다음과 같이 처리됩니다:</p>
//     <ul>
//       <li><strong>교환/반품 기간:</strong> 상품 수령 후 7일 이내 (의약품의 경우 포장 개봉 전에 한함)</li>
//       <li><strong>교환/반품 방법:</strong> 고객센터(080-855-8282) 또는 마이페이지에서 신청</li>
//       <li><strong>교환/반품 비용:</strong> 고객 변심의 경우 왕복 배송비 고객 부담, 상품 하자의 경우 회사 부담</li>
//       <li><strong>교환/반품 불가 상품:</strong>
//         <ul>
//           <li>포장을 개봉하거나 사용한 의약품</li>
//           <li>냉장/냉동 보관 의약품 (품질 보증 불가)</li>
//           <li>고객의 책임 있는 사유로 상품이 훼손된 경우</li>
//           <li>시간이 경과하여 재판매가 곤란한 경우</li>
//         </ul>
//       </li>
//     </ul>
//     <p class="guide-emphasis">의약품의 경우 약사법에 따라 교환/반품/환불에 제한이 있을 수 있습니다.</p>
//   </div>
//
//   <div class="guide-section">
//     <h4>고객센터 이용 안내</h4>
//     <ul>
//       <li><strong>운영시간:</strong> 월-금 09:00-18:00 (점심시간 12:30-13:30, 공휴일 휴무)</li>
//       <li><strong>전화문의:</strong> 080-855-8282</li>
//       <li><strong>이메일문의:</strong> contact@doctormarket.kr</li>
//       <li><strong>1:1 채팅문의:</strong> 웹사이트 우측 하단 채팅 아이콘 클릭</li>
//       <li><strong>FAQ:</strong> 자주 묻는 질문은 '고객센터 > FAQ' 메뉴에서 확인 가능합니다.</li>
//     </ul>
//     <p class="guide-emphasis">긴급한 의약품 관련 문의는 24시간 응대 가능한 긴급전화(080-855-8283)로 연락주세요.</p>
//   </div>
// </div>`
//         }
      ],

      storeConfig: {
        name: '',
        ceoName: '',
        businessNumber: '',
        phone: '',
        email: '',
        address1: '',
        address2: '',
        zipCode: '',
        logoUrl: ''
      }
    };
  },
  computed: {
    baseURL() {
      return getBaseURL();
    }
  },
  async mounted() {
    await this.loadStoreConfig();
    // 🔥 해피톡 초기화
    this.initHappytalk();
  },
  methods: {
    // 🔥 해피톡 초기화 메서드
    initHappytalk() {
      try {
        // 해피톡 SDK가 로드되었는지 확인
        if (typeof Happytalk !== 'undefined') {
          // 🔥 실제 SITE_ID, SITE_NAME, CATEGORY_ID, DIVISION_ID로 교체해야 합니다
          this.happytalk = new Happytalk({
            siteId: '1000427113', // 🔥 실제 사이트 ID로 교체
            siteName: '주식회사 에스디팜', // 🔥 실제 사이트 이름으로 교체
            categoryId: '201676', // 🔥 실제 카테고리 ID로 교체
            divisionId: '201677', // 🔥 실제 디비전 ID로 교체
            // partnerId: 'YOUR_PARTNER_ID', // 선택사항
            // shopId: 'YOUR_SHOP_ID', // 선택사항
            // params: 'site_uid=1', // 선택사항: 고정 파라미터
            // kakaoId: 'YOUR_KAKAO_ID', // 선택사항: 카카오톡 채널 ID
            // naverId: 'YOUR_NAVER_ID', // 선택사항: 네이버톡톡 채널 ID
          });

          console.log('✅ 해피톡 초기화 완료');
        } else {
          console.warn('⚠️ 해피톡 SDK가 로드되지 않았습니다.');
        }
      } catch (error) {
        console.error('❌ 해피톡 초기화 실패:', error);
      }
    },

    // �� 해피톡 상담창 열기 (개선된 버전)
    openHappytalk() {
      try {
        if (this.happytalk) {
          // 해피톡 인스턴스가 있으면 상담창 열기
          this.happytalk.open();
          console.log('✅ 해피톡 상담창 열기 성공');
        } else if (window.Happytalk) {
          // 전역 Happytalk 객체가 있으면 사용
          window.Happytalk.open();
          console.log('✅ 전역 해피톡 상담창 열기 성공');
        } else {
          // 해피톡이 없는 경우 대체 상담 페이지로 이동
          window.open('https://doctormarket.kr/support/inquiry', '_blank');
          console.log('⚠️ 해피톡 없음, 대체 상담 페이지로 이동');
        }
      } catch (error) {
        console.error('❌ 해피톡 상담창 열기 실패:', error);
        // 에러 발생 시 대체 상담 페이지로 이동
        window.open('https://doctormarket.kr/support/inquiry', '_blank');
      }
    },

    async loadStoreConfig() {
      try {
        this.isLoading = true;

        const response = await axios.get(`${this.baseURL}/api/config/store`);

        if (response.data) {
          this.storeConfig = {
            ...this.storeConfig,
            ...response.data
          };
          console.log('회사 정보 로드 완료:', this.storeConfig);
        }
      } catch (error) {
        console.error('회사 정보 로드 실패:', error);
        // 에러 발생 시 기본값 유지
      } finally {
        this.isLoading = false;
      }
    },

    getFullAddress() {
      const parts = [];
      if (this.storeConfig.address1) parts.push(this.storeConfig.address1);
      if (this.storeConfig.address2) parts.push(this.storeConfig.address2);

      return parts.length > 0
          ? parts.join(' ')
          : '서울시 영등포구 당산로51길11 금창빌딩 302호';
    },

    getImageUrl(imageUrl) {
      if (!imageUrl) return '';
      if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) return imageUrl;
      return `${this.baseURL}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    },

    // 모달 관련 메소드
    // methods 안의 openModal를 아래처럼 교체
    openModal(item) {
      // 링크가 지정된 메뉴는 새창으로 바로 열기
      if (item && item.href) {
        window.open(item.href, '_blank', 'noopener,noreferrer');
        return;
      }

      // 링크가 없으면 기존처럼 모달 오픈
      this.activeItem = item;
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    },

    closeModal() {
      this.isModalOpen = false;
      document.body.style.overflow = ''; // 배경 스크롤 복원
    }
  }
};
</script>

<style scoped>
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

.nebula-container {
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}
.nebula-container img {
  max-width: 100%;
  margin: 0 auto;
}
/* 상단 배너 */
.nebula-footer-banner {
  background-color: #17001C;
  padding: 0;
}

.nebula-banner-img {
  width: 100%;
  display: block;
}

/* 회사 메뉴 */
.nebula-company-menu {
  background-color: #f0f0f0;
  padding: 15px 0;
}

.nebula-menu-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.nebula-menu-item {
  margin-right: 20px;
}

.nebula-menu-item a {
  color: #333;
  text-decoration: none;
  font-size: 14px;
}

.nebula-menu-item a:hover {
  text-decoration: underline;
}

/* 회사 정보 */
.nebula-company-info {
  background-color: #f8f8f8;
  padding: 30px 0;
}

.nebula-info-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 30px;
}

.nebula-company-details {
  flex: 2;
  max-width: 25%;
  position: relative;
}

.nebula-company-logo {
  margin-bottom: 15px;
}

.nebula-company-logo img {
  max-width: 200px;
}

.nebula-company-text p {
  margin: 5px 0;
  font-size: 13px;
  color: #949494;
}

.nebula-company-intro-btn {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  padding: 8px 15px;
  background-color: #555;
  color: #fff;
  font-size: 13px;
  text-decoration: none;
  border-radius: 3px;
}

.nebula-company-intro-btn:hover {
  background-color: #444;
}

/* 고객센터 정보 */
.nebula-customer-center {
  flex: 1;
  max-width: 30%;
  padding: 0 15px;
}

.nebula-center-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.nebula-center-icon {
  margin-right: 8px;
}

.nebula-center-icon img {
  width: 24px;
  height: 24px;
}

.nebula-center-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.nebula-center-info p {
  margin: 5px 0;
  font-size: 13px;
  color: #666;
}

/* 문의 버튼 */
.nebula-contact-buttons {
  display: flex;
  gap: 15px;
  margin-top: 15px;
}

.nebula-contact-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  flex: 1;
  padding: 15px 10px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.nebula-contact-icon {
  margin-bottom: 8px;
}

.nebula-contact-icon img {
  width: 30px;
  height: 30px;
}

.nebula-contact-btn span {
  font-size: 12px;
  color: #333;
}

/* 인증 배지 */
.nebula-certifications {
  background-color: #fff;
  padding: 20px 0;
  border-top: 1px solid #eee;
}

.nebula-badges {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0px;
}

.nebula-badge {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 265px;
  border: 0px solid #eee;
  padding: 50px 0px;
  border-radius: 5px;
}

.nebula-badge img {
  margin-right: 0px;
}

.nebula-badge-text p {
  margin: 3px 0;
  font-size: 11px;
  color: #777;
}

/* 저작권 정보 */
.nebula-copyright {
  background-color: #f0f0f0;
  padding: 15px 0;
  text-align: center;
}

.nebula-copyright p {
  margin: 0;
  font-size: 12px;
  color: #999;
}

/* 스켈레톤 공통 */
/* 기본 스타일 유지 */
.nebula-site-footer {
  font-family: 'Noto Sans KR', sans-serif;
  color: #333;
}

/* 스켈레톤용 스타일 */
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: pulse 1.5s ease-in-out infinite;
  border-radius: 6px;
  margin-bottom: 10px;
}

.skeleton-banner {
  height: 80px;
  margin: 10px 0;
}

.skeleton-menu {
  height: 50px;
  margin: 10px 0;
}

.skeleton-company {
  height: 220px;
}

.skeleton-customer {
  height: 160px;
}

.skeleton-badges {
  height: 140px;
}

.skeleton-copyright {
  height: 40px;
  margin-top: 10px;
}

@keyframes pulse {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 반응형 스타일 */
@media (max-width: 992px) {
  .nebula-info-grid {
    flex-direction: column;
  }

  .nebula-company-details,
  .nebula-customer-center {
    max-width: 100%;
  }

  .nebula-badges {
    justify-content: center;
  }

  .nebula-badge {
    flex: 0 0 calc(50% - 15px);
  }

}

@media (max-width: 768px) {
  .nebula-company-details {
    padding-bottom: 20px;
  }

  .nebula-company-intro-btn {
    position: static;
    margin-top: 15px;
  }

  .nebula-badges {
   display: none;
  }
}

@media (max-width: 576px) {
  .nebula-menu-list {
    flex-wrap: wrap;
  }

  .nebula-menu-item {
    margin-bottom: 5px;
  }

  .nebula-contact-buttons {
    flex-wrap: wrap;
  }

  .nebula-contact-btn {
    flex: 0 0 calc(33.33% - 10px);
  }
}

/* 모달 스타일 추가 */
.nebula-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.nebula-modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.nebula-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.nebula-modal-header h2 {
  margin: 0;
  font-size: 20px;
  color: #333;
}

.nebula-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #777;
  padding: 0;
  margin: 0;
  line-height: 1;
}

.nebula-modal-body {
  padding: 20px;
  line-height: 1.6;
}

.nebula-modal-body h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #ff4848;
}

.nebula-modal-body p {
  margin: 0 0 10px 0;
  font-size: 14px;
}

/* 반응형 모달 스타일 */
@media (max-width: 576px) {
  .nebula-modal-content {
    width: 95%;
    max-height: 90vh;
  }

  .nebula-modal-header {
    padding: 15px;
  }

  .nebula-modal-header h2 {
    font-size: 18px;
  }

  .nebula-modal-body {
    padding: 15px;
  }
}

/* 모달 내용 스타일링 */
.modal-content {
  line-height: 1.6;
  color: #333;
}

.modal-content h3 {
  color: #ff4848;
  margin-bottom: 20px;
  font-size: 22px;
  border-bottom: 2px solid #ff4848;
  padding-bottom: 10px;
}

.modal-content h4 {
  color: #333;
  margin: 20px 0 10px;
  font-size: 18px;
}

.modal-content h5 {
  color: #ff4848;
  margin: 15px 0 10px;
  font-size: 16px;
}

.company-section, .terms-section, .privacy-section, .guide-section {
  margin-bottom: 25px;
}
.privacy-section {padding-top:25px;}
.modal-content p {
  margin: 0 0 15px;
  font-size: 14px;
}

.modal-content ul, .modal-content ol {
  padding-left: 20px;
  margin-bottom: 15px;
}

.modal-content li {
  margin-bottom: 8px;
  font-size: 14px;
}

.guide-note {
  background-color: #f8f8f8;
  padding: 15px;
  border-radius: 5px;
  margin: 15px 0;
}

.guide-emphasis {
  font-weight: 500;
  color: #ff4848;
}

.timeline {
  border-left: 2px solid #ddd;
  padding-left: 20px;
  list-style: none;
}

.timeline li {
  position: relative;
  padding-bottom: 15px;
}

.timeline li:before {
  content: '';
  position: absolute;
  left: -27px;
  top: 5px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ff4848;
}

.privacy-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.privacy-table th, .privacy-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  font-size: 13px;
}

.privacy-table th {
  background-color: #f8f8f8;
}

.terms-note, .privacy-note {
  font-size: 13px;
  color: #777;
  font-style: italic;
  margin-top: 30px;
}

@media (max-width: 768px) {
  .modal-content h3 {
    font-size: 20px;
  }

  .modal-content h4 {
    font-size: 16px;
  }

  .privacy-table th, .privacy-table td {
    font-size: 12px;
    padding: 6px;
  }
}

</style>